<template>
  <div id="Occupation">
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step2.occupation.title") }}</div>
      <div class="container inline bottom">
        <EnergyButton 
          @click="occupation = 'summer'"
          :active="occupation === 'summer'"
          :title="$t('step2.occupation.summer')"
          type="occupation-summer"
        />
        <EnergyButton 
          @click="occupation = 'evening_weekend'"
          :active="occupation === 'evening_weekend'"
          :title="$t('step2.occupation.evening_weekend')"
          type="occupation-evening_weekend"
        />
      <!-- </div>
      <div class="container inline top"> -->
        <EnergyButton 
          @click="occupation = 'weekend_holidays'"
          :active="occupation === 'weekend_holidays'"
          :title="$t('step2.occupation.weekend_holidays')"
          type="occupation-weekend_holidays"
        />
        <EnergyButton 
          @click="occupation = 'always'"
          :active="occupation === 'always'"
          :title="$t('step2.occupation.always')"
          type="occupation-always"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EnergyButton from "@/components/Energy/EnergyButton.vue";

export default {
  computed: {
    occupation: {
      get() {
        return this.$store.state.consumption.occupation;
      },
      set(value) {
        this.$store.commit("consumption/setOccupation", value);
      }
    }
  },
  components: {
    EnergyButton
  }
};
</script>


// WEBPACK FOOTER //
// src/views/consumption/KnowConsumption/Occupation.vue